import React from 'react';
import { StyleSheet, ScrollView, Text } from 'react-native';

import { ListItem } from '@rneui/themed';
import { AntDesign } from '@expo/vector-icons';
import MenuItem from './MenuItem';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    justifyContent: 'center',
  },
  list: {
    width: '100%',
    backgroundColor: '#000',
  },
});

interface ListProps {
  title?: string;
  tableList: Array<{
    type_id: string;
    name: string;
    description: string;
    image: string;
  }>;
  disabled?: boolean;
}

const List: React.FC<ListProps> = ({ title, tableList, disabled = false }) => {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <ListItem.Accordion
      content={
        <ListItem.Content>
          <ListItem.Title>
            <Text>{title}</Text>
          </ListItem.Title>
        </ListItem.Content>
      }
      isExpanded={expanded}
      onPress={() => {
        setExpanded(!expanded);
      }}
      icon={<AntDesign name="up" size={24} color="black" />}
      style={styles.container}
      disabledStyle={{ backgroundColor: 'lightgray' }}
      disabled={disabled}
    >
      <ScrollView>
        {tableList.map((item, key) => (
          <MenuItem item={item} key={key} />
        ))}
      </ScrollView>
    </ListItem.Accordion>
  );
};

List.defaultProps = {
  title: 'Table List',
};

export default List;
